import React from "react";
import { Box, Typography } from "@mui/material";
import { T } from "utils/backrrTokens";

export const VARIANTS = [
  // { key: "v1", label: "V1", title: "Shipped" },
  { key: "a", label: "A", title: "Calm violet" },
  { key: "b", label: "B", title: "Midnight console" },
  { key: "c", label: "C", title: "Insight-first" },
];

const STORAGE_KEY = "backrr_dashboard_variant";
export const DEFAULT_VARIANT = "a";

// Remembered per browser, so comparing directions survives a reload and nobody
// else's screen changes. localStorage can throw in a private window, so every
// access is guarded and the default is variant A.
export const readVariant = () => {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return VARIANTS.some((v) => v.key === saved) ? saved : DEFAULT_VARIANT;
  } catch (e) {
    return DEFAULT_VARIANT;
  }
};

export const writeVariant = (key) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, key);
  } catch (e) {
    /* a private window is not a reason to break the page */
  }
};

const VariantSwitcher = ({ value, onChange }) => {
  const active = VARIANTS.find((v) => v.key === value) ?? VARIANTS[0];

  return (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      <Typography sx={{ fontSize: "0.72rem", color: T.inkSubtle }}>Design</Typography>
      <Box
        role="group"
        aria-label="Dashboard design variant"
        sx={{ display: "inline-flex", padding: "3px", borderRadius: "8px", background: T.pill }}
      >
        {VARIANTS.map((v) => {
          const selected = v.key === value;
          return (
            <Box
              key={v.key}
              component="button"
              type="button"
              aria-pressed={selected}
              title={v.title}
              onClick={() => onChange(v.key)}
              sx={{
                border: 0,
                cursor: "pointer",
                font: "inherit",
                fontSize: "0.72rem",
                fontWeight: selected ? 700 : 500,
                padding: "4px 10px",
                borderRadius: "6px",
                background: selected ? T.surface : "transparent",
                color: selected ? T.accent : T.inkSubtle,
                boxShadow: selected ? "0 1px 2px rgba(16,24,40,0.06)" : "none",
                "&:focus-visible": { outline: `2px solid ${T.accent}`, outlineOffset: "1px" },
              }}
            >
              {v.label}
            </Box>
          );
        })}
      </Box>
      {/* <Typography sx={{ fontSize: "0.72rem", color: T.inkSubtle }}>{active.title}</Typography> */}
    </Box>
  );
};

export default VariantSwitcher;
